import { POSTS_PAGE } from '@/constants/pages';

export const buildCommentUrl = (postSlug: string, commentId: number | string, isAbsolute = false) => {
  const baseUrl = process.env.internalBaseUrl;
  return `${isAbsolute ? baseUrl : ''}${POSTS_PAGE.path}/${postSlug}#comment-${commentId}`;
};

export const prepareCommentText = (text: string | null): string => {
  return text ? text.split(/<br\s*\/?>/gi)[0] : '';
};
